import React from 'react';

export default function SalesSolutionsPage() {
  return (
    <div className="min-h-screen bg-white font-light">
      {/* Hero */}
      <div className="px-8 pt-32 pb-24">
        <div className="max-w-5xl mx-auto">
          <div className="mb-16">
            <h1 className="text-7xl md:text-8xl font-extralight tracking-tight text-black mb-6">
              Sales
            </h1>
            <h1 className="text-7xl md:text-8xl font-extralight tracking-tight text-black mb-12">
              Solutions
            </h1>
            <div className="w-16 h-px bg-black"></div>
          </div>
          
          <p className="text-2xl md:text-3xl font-extralight text-gray-800 leading-relaxed max-w-4xl">
            Set up and manage online and in-store sales with an integrated POS system for smooth transactions.
          </p>
        </div>
      </div>

      {/* Services */}
      <div className="px-8 py-32">
        <div className="max-w-5xl mx-auto">
          <div className="space-y-24">
            {/* E-commerce & POS */}
            <div className="grid md:grid-cols-12 gap-8 items-start">
              <div className="md:col-span-3">
                <h2 className="text-xl font-normal text-black tracking-wide">
                  E-COMMERCE & POS
                </h2>
              </div>
              <div className="md:col-span-9">
                <div className="space-y-12">
                  <div className="border-b border-gray-200 pb-8">
                    <h3 className="text-3xl font-extralight text-black mb-4">
                      Online Store Setup
                    </h3>
                    <p className="text-lg text-gray-600 font-light">
                      Seamlessly launch your digital presence with intuitive design
                    </p>
                  </div>
                  
                  <div className="border-b border-gray-200 pb-8">
                    <h3 className="text-3xl font-extralight text-black mb-4">
                      POS Integration
                    </h3>
                    <p className="text-lg text-gray-600 font-light">
                      Unified system connecting every transaction touchpoint
                    </p>
                  </div>
                  
                  <div className="border-b border-gray-200 pb-8">
                    <h3 className="text-3xl font-extralight text-black mb-4">
                      Inventory Management
                    </h3>
                    <p className="text-lg text-gray-600 font-light">
                      Real-time visibility across all sales channels
                    </p>
                  </div>
                  
                  <div className="pb-8">
                    <h3 className="text-3xl font-extralight text-black mb-4">
                      Payment Processing
                    </h3>
                    <p className="text-lg text-gray-600 font-light">
                      Secure, global payment infrastructure at scale
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="px-8 py-32 border-t border-gray-100">
        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-5xl font-extralight text-black leading-tight">
                Transform your sales infrastructure
              </h2>
            </div>
            <div className="md:text-right">
              <button className="group inline-flex items-center space-x-4 text-black hover:text-gray-600 transition-colors duration-300">
                <span className="text-lg font-light tracking-wide">Start conversation</span>
                <div className="w-12 h-px bg-black group-hover:w-16 transition-all duration-300"></div>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="px-8 py-16 border-t border-gray-100">
        <div className="max-w-5xl mx-auto">
          <div className="text-sm font-light text-gray-500 tracking-widest">
            © 2025
          </div>
        </div>
      </div>
    </div>
  );
}